import { render, staticRenderFns } from "./Bm.vue?vue&type=template&id=54801cdf&scoped=true"
import script from "./Bm.vue?vue&type=script&lang=js"
export * from "./Bm.vue?vue&type=script&lang=js"
import style0 from "./Bm.vue?vue&type=style&index=0&id=54801cdf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54801cdf",
  null
  
)

export default component.exports